import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { guestGuard } from './core/guards/guest.guard';
import { twoFactorGuard } from './core/guards/two-factor.guard';
import { adminGuard, flagsInboxGuard } from './core/guards/admin.guard';
import {
  adminBillingOverviewGuard,
  clientBillingFeatureGuard
} from './core/guards/billing-feature.guard';
import { subscriptionAccessGuard } from './core/guards/subscription-access.guard';
import { termsFeatureCanMatch, termsFeatureGuard } from './core/guards/terms-feature.guard';
import { termsEditorCanMatch, termsEditorGuard } from './core/guards/terms-editor.guard';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [guestGuard],
    loadComponent: () =>
      import('./features/auth/login/login.component').then((m) => m.LoginComponent)
  },
  {
    path: '2fa',
    canActivate: [twoFactorGuard],
    loadComponent: () =>
      import('./features/auth/two-factor/two-factor.component').then((m) => m.TwoFactorComponent)
  },
  {
    path: 'invite',
    loadComponent: () =>
      import('./features/auth/invite/invite.component').then((m) => m.InviteComponent)
  },
  {
    // Public when enabled: linked from checkout and sign-in, and clause 1.5 lets a
    // customer download the accepted version after their access has ended.
    // environment / runtime showTerms false → canMatch blocks the route (no lazy load, no URL).
    path: 'legal/terms',
    canMatch: [termsFeatureCanMatch],
    canActivate: [termsFeatureGuard],
    loadComponent: () =>
      import('./features/legal/terms-page.component').then((m) => m.TermsPageComponent)
  },
  {
    path: 'app',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./layout/app-shell/app-shell.component').then((m) => m.AppShellComponent),
    children: [
      {
        path: '',
        redirectTo: 'smartfreight/rates',
        pathMatch: 'full'
      },
      {
        path: 'smartfreight/rates',
        canActivate: [subscriptionAccessGuard],
        loadComponent: () =>
          import('./features/smartfreight/rates/smartfreight-rates.component').then(
            (m) => m.SmartFreightRatesComponent
          )
      },
      {
        path: 'admin',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./features/admin/admin.component').then((m) => m.AdminComponent)
      },
      {
        path: 'audit',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./features/admin/audit-trail-page/audit-trail-page.component').then(
            (m) => m.AuditTrailPageComponent
          )
      },
      {
        path: 'admin/flags',
        canActivate: [flagsInboxGuard],
        loadComponent: () =>
          import('./features/admin/admin-flags-page.component').then(
            (m) => m.AdminFlagsPageComponent
          )
      },
      {
        path: 'billing',
        canActivate: [clientBillingFeatureGuard],
        loadComponent: () =>
          import('./features/billing/client-billing-page.component').then(
            (m) => m.ClientBillingPageComponent
          )
      },
      {
        path: 'admin/billing',
        // Always on for Irish Taylor admins — not tied to showBilling.
        canActivate: [adminGuard, adminBillingOverviewGuard],
        loadComponent: () =>
          import('./features/admin/admin-billing-page.component').then(
            (m) => m.AdminBillingPageComponent
          )
      },
      {
        // Separate staff-only page — not under Admin Panel. canMatch blocks the
        // lazy load for anyone who is not an Irish Taylor staff admin.
        path: 'staff/terms-editor',
        canMatch: [termsEditorCanMatch],
        canActivate: [termsEditorGuard],
        loadComponent: () =>
          import('./features/admin/legal/terms-editor-page.component').then(
            (m) => m.TermsEditorPageComponent
          )
      }
    ]
  },
  {
    path: '',
    redirectTo: 'app/smartfreight/rates',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: 'app/smartfreight/rates'
  }
];
